import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

/* all children should be LineItem components */
/* see ../LineItem */
const DetailList = ({ children, className, columnLayout }) => (
  <dl className={cx('m-0 grid gap-x-8 gap-y-2', columnLayout, className)}>
    {children}
  </dl>
);

DetailList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /* columnLayout should be a tailwind grid column layout class, e.g. grid-cols-2
   * see: https://tailwindcss.com/docs/grid-template-columns */
  columnLayout: PropTypes.string,
};

DetailList.defaultProps = {
  className: '',
  columnLayout: 'grid-cols-2',
};

export default DetailList;
